<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="sendToShipmentModal" persistent max-width="450px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <div class="col-sm-10"><span class="headline">{{ $t('sendToShipment.title') }}</span></div>
              <div class="col-sm-2">
                <v-btn flat @click="closeSendToShipmentModal" class="close"><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </div>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs10 sm5 md4>
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('columns.qrCode') + '*'"
                      v-model="sendToShipmentData.qrcode"
                      :error-messages="errors.collect('qrcode')"
                      v-validate="'required'"
                      data-vv-name="qrcode"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div style="height:0px;overflow:hidden">
                <v-btn id="sendButton" type="submit" style="height:auto" outline color="success"
                  >{{ $t('orders.sendTooltip') }}</v-btn
                >
              </div>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'sendToShipmentModal',
    'closeSendToShipmentModal',
    'sendToShipmentData',
    'sendToShipment'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.sendToShipment()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/sendToShipment.vue